import { DynamicDecorator } from '../../DynamicDecorator/DynamicDecorator';

export const NumbersDecorator = () => (
  <>
    <DynamicDecorator
      decorator="circle"
      className="text-primary-600 absolute -top-8 left-[50%] h-[18px] w-[18px] md:-left-4 md:top-[calc(50%+60px)]"
    />
    <DynamicDecorator
      decorator="quadrant"
      className="text-naturaily-butterscotch absolute -top-12 left-[45%] h-[18px] w-[18px] rotate-[-90deg] md:-left-10 md:top-[calc(50%+30px)]"
    />
    <DynamicDecorator
      decorator="quadrant"
      className="text-naturaily-airborne absolute -bottom-12 left-[42%] h-6 w-6 md:-right-6 md:bottom-auto md:left-auto md:top-[calc(50%-70px)]"
    />
    <DynamicDecorator
      decorator="circle"
      className="text-naturaily-butterscotch absolute -bottom-16 left-[51%] h-[18px] w-[18px] md:-right-10 md:bottom-auto md:left-auto md:top-[calc(50%-20px)]"
    />
  </>
);
